export const STATUS_EMPTY = 'STATUS_EMPTY';
export const STATUS_START = 'STATUS_START';
export const STATUS_SUCCESS = 'STATUS_SUCCESS';
export const STATUS_FAIL = 'STATUS_FAIL';